import * as React from "react";
import Footer from "../components/Footer";
import Rating from "@mui/material/Rating";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import Global, { formatLongNumber, isAdminAccount } from "../util/Global";
import { AlertContext } from "../util/Alerter";
import { LoaderComponent } from "../util/Loader";
import ProductsComponent from "../components/Products/ProductsComponent";
import NotFound from "../components/NotFound";
import { HeaderContext } from "../components/Header";
import { useContext } from "react";
import { Chip } from "@mui/material";
import { CurrencyContext, DeliveryCountryContext, getUserFullName, QrCodeImageGenerator } from "../components/Utils";
import { GlobalData } from "../util/GlobalData";

const DetailProduit = () => {

  const { id } = useParams();
  const [productDetails, setProductDetails] = useState(null);
  const [qt, setQt] = useState(0);
  const [isLoading, setisLoading] = useState(true);
  const [value, setValue] = useState(0);
  const [comment, setComment] = useState("");
  const [moyCustomerRate, setmoyCustomerRate] = useState(0);
  const [countCustomerReviews, setcountCustomerReviews] = useState(0);
  const [commentList, setCommentList] = useState([]);

  const [selectedImage, setselectedImage] = useState(0);
  const { cartCount, setcartCount } = useContext(HeaderContext)
  const { currency, getCurrencyPrice } = useContext(CurrencyContext)
  const {deliveryCountry}=useContext(DeliveryCountryContext)

  const { t } = useTranslation();
  const [showAvis, setShowAvis] = useState(false);
  const [productList, setProductList] = useState([]);
  const { showAlert } = useContext(AlertContext)
  const navigate = useNavigate()
  const userId = localStorage.getItem("id")


  const PRODUCT_DETAILS_URL = Global.backend + "/index.php/produit/show";
  const PRODUCT_VU_URL = Global.backend + "/index.php/produit/addVu";
  const ADD_CART_URL = Global.backend + "/index.php/api/panier/new";
  const ADD_AVIS_URL = Global.backend + "/index.php/api/avis/new";
  const AVIS_URL = Global.backend + "/index.php/avis/avisofproduct";
  const SHOW_AVIS_OR_NOT_URL = Global.backend + "/index.php/avis/showAvisOrNot";
  const PRODUCT_URL = Global.backend + "/index.php/produit/showall";





  useEffect(() => {
    setisLoading(true)

    axios.all([
      axios.post(AVIS_URL, { produitId: id }),
      axios.post(SHOW_AVIS_OR_NOT_URL, { produitId: id }),
      axios.post(PRODUCT_URL,{deliveryCountry}),
      axios.post(PRODUCT_DETAILS_URL, { produitId: id }),
    ]).then(axios.spread((commentResponse, showAvisResponse, productResponse, productDetailsResponse) => {
      // add view to product
      if (!productDetailsResponse.data) {
        return
      }

      axios.post(PRODUCT_VU_URL, { produitId: id }).catch(() => { })


      const comments = commentResponse.data
      let commentsRateMoy = 0

      for (let a = 0; a < comments.length; a++) {
        commentsRateMoy += comments[a].etoile_nb
      }
      commentsRateMoy /= comments.length


      setShowAvis(showAvisResponse.data)



      // filter related typology products
      var prod = []
      productResponse.data.slice().reverse().map((item) => {
        if (item.visibilite == true && item.id != id && item.typologie == productDetailsResponse.data.typologie) {
          prod.push(item);
        }
      })


      // show review or not based on user order (fake or not)
      //setShowAvis(avisResponse.data)
      setCommentList(comments)
      setcountCustomerReviews(comments.length)
      setmoyCustomerRate(commentsRateMoy)
      setProductList(prod)
      setProductDetails(productDetailsResponse.data)
      setQt(productDetailsResponse.data.min)
    })).catch((err) => {
      showAlert("error", t("request.errorFetchProductDetails"))
    }).finally(() => {
      setisLoading(false)
    })
  }, [id]);








  const handleBasicClick = (value) => {
    if (value === selectedImage) {
      return;
    }

    setselectedImage(value)
  };

  const AddAlert = () => {
    if (!userId) {
      showAlert("error", t("detailproduit1.1"))
    } else {
      fetchAddToCart();
    }
  };










  function fetchAddAvis() {
    if (!userId) {
      showAlert("error", t("detailproduit1.1"))
    } else {
      setisLoading(true)
      axios
        .post(ADD_AVIS_URL, {
          produitId: id,
          etoileNb: value,
          commentaire: comment,
        }).then(() => {
          showAlert("success", t("request.successPostingComment"))
          setValue(0);
          setComment("");
          axios.post(AVIS_URL, { produitId: id }).then((response) => {
            setCommentList(response.data)
          }).catch(() => { })
        })
        .finally(() => {
          setisLoading(false);
        });
    }
  }


  function fetchAddToCart() {
    setisLoading(true)
    axios.post(ADD_CART_URL, {
      produitId: id,
      quantite: qt,
    }).then((response) => {
      if (response.data.message == "nok" || response.data.message == "erreur") {
        showAlert("error", t("detailproduit4.1"))
      } else if (response.data.message == "updated") {
        // updated allready added product
        showAlert("success", t("detailproduit5.1"))
      } else {
        // new product added
        setcartCount(cartCount + 1)
        showAlert("success", t("detailproduit5.1"))
      }
    }).catch((err) => {
      showAlert("error", t("detailproduit4.1"))

    }).finally(() => {
      setisLoading(false)
    });
  }

  function updateQt(newQt) {
    if (newQt >= productDetails.min && newQt <= productDetails.max) {
      setQt(newQt);
    }
  }


  return (
    <div>
      <LoaderComponent isLoading={isLoading}>
        {!isLoading && (!productDetails ? <NotFound /> :
          <section className="ttm-row conatact-section ttm-bgcolor-grey mb_20 clearfix mt-5">
            <div className="container">
              <div className="row ttm-boxes-spacing-30px">
                <div className="col-md-6 col-sm-6 ttm-box-col-wrapper">
                  <div className="ttm_single_image-wrapper border-rad_5">

                    <div className="preview">
                      <div className="preview-pic tab-content w-50 ml-auto mr-auto">
                        <div
                          className={"tab-pane product-detail-image w-100 active"}
                          id="pic-1"

                        >
                          <img
                            src={productDetails.image[selectedImage]?.imageURL ? `${Global.backend}/uploads/${productDetails.image[selectedImage].imageURL}` : require("../assets/img/default_product.png")}
                          />
                        </div>
                      </div>
                      <ul className="preview-thumbnail nav nav-tabs">
                        {productDetails.image?.map((img, index) => {
                          return (
                            <li
                              key={index}
                              onClick={() =>
                                handleBasicClick(index)
                              }
                            >
                              <a data-target="#pic-2" data-toggle="tab" className={selectedImage === index ? "active" : ""}>
                                <img
                                  src={`${Global.backend}/uploads/${img.imageURL}`}
                                />
                              </a>
                            </li>
                          )
                        })}
                      </ul>
                    </div>

                  </div>
                </div>
                <div className="col-md-6 col-sm-6 ttm-box-col-wrapper">
                  <div className="ttm_single_image-wrapper border-rad_5">
                    {productDetails.stock > 0 ? (
                      <p
                        className="btn text-success border-2 rounded-pill border-success mb-3"
                      >
                        {t("inStock")}
                      </p>
                    ) : (
                      <p
                        className="btn text-danger border-2 rounded-pill border-danger mb-3"
                      >
                        {t("outOfStock")}
                      </p>
                    )}

                    <div className="">
                      <h3 >{productDetails.nom} </h3>
                      <div className="d-flex">
                        {productDetails.user.id == userId && <h5 className="text-primary h-100">({t("yourProduct")})</h5>}
                        {isAdminAccount() && <Chip className="ml-2" label={t(productDetails.visibilite ? "product.visible" : "product.invisible")} color={productDetails.visibilite ? "success" : "error"} />}
                      </div>
                    </div>





                    <div className="mb-3 d-flex">
                      <Rating
                        name="half-rating-read"
                        value={moyCustomerRate}
                        precision={0.1}
                        readOnly
                      />

                      <p>
                        ({countCustomerReviews} {t("customerreviews")})
                      </p>
                    </div>


                    <div className="mb-3">
                      <h6 className="d-inline">{t("product.description")} : </h6>
                      <p className="details-p d-inline m-0 p-0 ">
                        {productDetails.description}
                      </p>
                    </div>



                    <div className="mb-3">
                      <h6 className="d-inline">{t("stock")} : </h6>
                      <p className="details-p d-inline m-0 p-0 ">
                        <span className="tick">✔</span>
                        {productDetails.stock}
                      </p>



                      <p className="details-p m-0 p-0 pl-2 d-inline">
                        <span className="bold"> {t("min")}: </span>
                        {productDetails.min}
                      </p>
                      <p className="details-p m-0 p-0 pl-2 d-inline">
                        <span className="bold"> {t("max")}: </span>
                        {productDetails.max}
                      </p>
                    </div>


                    <div className="mb-3">
                      <h6 className="d-inline">{t("productCurrency")} : </h6>
                      <p className="details-p d-inline m-0 p-0 ">
                        {productDetails.currency}
                      </p>
                    </div>







                    <div className="d-flex mb-3">
                      <h6 className="d-inline">{t("product.prix")} : </h6>
                      <h5>
                        {productDetails.discount ?
                          <>
                            {GlobalData.currency[currency]}{getCurrencyPrice(productDetails.prix - (productDetails.prix / 100 * productDetails.discount), productDetails.currency)} &nbsp;
                          </>
                          :
                          <>
                            {GlobalData.currency[currency]}{getCurrencyPrice(productDetails.prix, productDetails.currency)} &nbsp;
                          </>
                        }

                        {productDetails.discount && (
                          <>
                            <span
                              style={{
                                backgroundColor: "red",
                                color: "white",
                                padding: 2,
                                borderRadius: 5,
                                fontWeight: "bold",
                              }}
                            >
                              -{productDetails.discount}%
                            </span>
                            <span
                              style={{
                                padding: 2,
                                fontSize: 18,
                                textDecoration: "line-through",
                                fontWeight: "normal",
                              }}
                            >
                              &nbsp; {GlobalData.currency[currency]}{getCurrencyPrice(productDetails.prix, productDetails.currency)}
                            </span>
                          </>
                        )}
                      </h5>
                    </div>


                    {productDetails.traceabilityURL && (
                      <div className="mb-3">
                        <h6>{t("product.traceabilityURL")}:</h6>
                        <div className="details-p text-center">
                          <QrCodeImageGenerator text={productDetails.traceabilityURL} />
                        </div>
                        <div className="text-center mt-2">
                          <a
                            href={productDetails.traceabilityURL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
                            style={{ textDecoration: "none", padding: "5px 15px", borderRadius: "20px" }}
                          >
                            <i className="fas fa-shield-alt mr-2"></i>
                            <span>{t("blockchainVerified")}</span>
                          </a>
                        </div>
                      </div>
                    )}

                    {productDetails.stock > 0 && (
                      <div className="container ml-0 p-0 mt-5 ">
                        <div className="row">
                          <div className="col-md-4 ">
                            <table>
                              <tbody>
                                <tr>
                                  <td>
                                    <button
                                      className="btn product-price-btn moin"
                                      disabled={productDetails.user.id == userId}
                                      onClick={() => updateQt(qt - 1)}
                                    >
                                      -
                                    </button>
                                  </td>
                                  <td>
                                    <input
                                      style={{ backgroundColor: "#F5F7FA" }}
                                      type="text"
                                      className="product-price-input d-flex justify-content-center align-items-center text-center"
                                      value={qt}
                                      onChange={(e) => setQt(e.target.value)}
                                    />
                                  </td>
                                  <td>
                                    <button
                                      className="btn product-price-btn plus"
                                      disabled={productDetails.user.id == userId}
                                      onClick={() => updateQt(qt + 1)}
                                    >
                                      +
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="col-md-8">
                            <button
                              className="btn btn-success product-add-to-cart-btn rounded-pill w-100"
                              disabled={productDetails.user.id == userId}
                              onClick={() => AddAlert()}
                            >
                              {t("addtoCart")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>


              <div className="row">
                <div className="ttm-bgcolor-white p-30 border-rad_5 margin_top15" style={{ width: "100%" }}>
                  <Tabs
                    style={{ width: "100%" }}
                  >
                    <TabList>
                      <Tab>{t("product.specs")}</Tab>
                      <Tab>{t("product.processingDetails")}</Tab>
                      <Tab>{t("detailproduit6.1")}</Tab>
                      {userId &&
                        <>
                          <Tab>{t("detailproduit8.1")}</Tab>
                          <Tab>{t("comment")}</Tab>
                        </>
                      }
                    </TabList>



                    <TabPanel>
                      <div style={{ marginTop: 20 }}>
                        <h4>{t("product.specs")}</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-5">
                          <div className="ligne">
                            <span className="titleligne">{t("deliveryCountries")}</span>
                            <span className="descriptionligne">{productDetails.deliveryCountries}</span>
                          </div>

                          <div className="ligne">
                            <span className="titleligne">{t("product.typologie")}</span>
                            <span className="descriptionligne">{t("product.typologies." + productDetails.typologie)}</span>
                          </div>


                          <div className="ligne">
                            <span className="titleligne">{t("product.productionCountry")}</span>
                            <span className="descriptionligne">{productDetails.productionCountry}</span>
                          </div>




                          <div className="ligne">
                            <span className="titleligne">{t("product.datedepeche")}</span>
                            <span className="descriptionligne">{productDetails.datedepeche}</span>
                          </div>









                          <div className="ligne">
                            <span className="titleligne">{t("product.capture")}</span>
                            <span className="descriptionligne">{t("product.captures." + productDetails.methodedecapture)}</span>
                          </div>


                        </div>
                      </div>
                    </TabPanel>





                    <TabPanel>
                      <div style={{ marginTop: 20 }}>
                        <h4>{t("product.processingDetails")}</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-5">

                          <div className="ligne">
                            <span className="titleligne">{t("product.transformation")}</span>
                            <span className="descriptionligne">{t("product.transformations." + productDetails.transformation)}</span>
                          </div>



                          <div className="ligne">
                            <span className="titleligne">{t("product.conservation")}</span>
                            <span className="descriptionligne">{t("product.conservations." + productDetails.conservation)}</span>
                          </div>





                          <div className="ligne">
                            <span className="titleligne">{t("product.congelation")}</span>
                            <span className="descriptionligne">{t("product.congelations." + productDetails.congelation)}</span>
                          </div>



                          <div className="ligne">
                            <span className="titleligne">{t("product.glazing")}</span>
                            <span className="descriptionligne">{productDetails.glazing} °C</span>
                          </div>




                          <div className="ligne">
                            <span className="titleligne">{t("product.taille")}</span>
                            <span className="descriptionligne">{productDetails.taille} Cm</span>
                          </div>




                          <div className="ligne">
                            <span className="titleligne">{t("product.certification")}</span>
                            <span className="descriptionligne">{t("product.certifications." + productDetails.certification)}</span>
                          </div>





                          <div className="ligne">
                            <span className="titleligne">{t("product.emballage")}</span>
                            <span className="descriptionligne">{t("product.emballages." + productDetails.emballage)}</span>
                          </div>




                          <div className="ligne">
                            <span className="titleligne">{t("product.poidemballage")}</span>
                            <span className="descriptionligne">{formatLongNumber(productDetails.poidemballage)} G</span>
                          </div>


                        </div>
                      </div>
                    </TabPanel>







                    <TabPanel>
                      <div style={{ marginTop: 20 }}>
                        <h4>{t("detailproduit6.1")} </h4>
                      </div>
                      <div className="row">
                        <div className="col-md-5">

                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit10.1")}:</span>
                            <span className="descriptionligne">{productDetails.user.entreprise?.nom}</span>
                          </div>





                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit11.1")} :</span>
                            <span className="descriptionligne">{t("user.activities." + productDetails.user?.entreprise?.activite)}</span>
                          </div>




                          <div className="ligne">
                            <span className="titleligne">{t("user.pays")}:</span>
                            <span className="descriptionligne">{productDetails.user.entreprise?.pays}</span>
                          </div>



                          <div className="ligne">
                            <span className="titleligne">{t("user.address")}:</span>
                            <span className="descriptionligne">{productDetails.user.entreprise?.adresse}</span>
                          </div>


                          <div className="ligne">
                            <span className="titleligne">{t("user.city")}  </span>
                            <span className="descriptionligne">{productDetails.user.entreprise?.ville}</span>
                          </div>


                          <div className="ligne">
                            <span className="titleligne">{t("user.postalCode")}  </span>
                            <span className="descriptionligne">{productDetails.user.entreprise?.code_postal}</span>
                          </div>



                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit13.1")}: </span>
                            <span className="descriptionligne">{productDetails.user?.entreprise?.email}</span>
                          </div>







                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit15.1")}: </span>
                            <span className="descriptionligne">{productDetails.user.entreprise?.tel}</span>
                          </div>






                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit16.1")}: </span>
                            <span className="descriptionligne">{productDetails.user.civilite ? t("user.civilities." + productDetails.user.civilite) : ""} {productDetails.user.prenom} {productDetails.user.nom}</span>
                          </div>





                          <div className="ligne">
                            <span className="titleligne">{t("detailproduit17.1")}  </span>
                            <span className="descriptionligne">{t("user.services." + productDetails.user.service)} {"/"} {t("user.functions." + productDetails.user.fonction)}</span>
                          </div>




                        </div>
                      </div>


                      <div className="row">
                        <button
                          className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor d-print-none"

                          onClick={() => {
                            navigate(`/entreprise/${productDetails.user?.entreprise?.nom}`)
                          }}
                        >
                          <span>{t("aboutCompany")} <i className="fa fa-chevron-right"></i></span>
                        </button>
                      </div>
                    </TabPanel>








                    {userId && (
                      <>
                        <TabPanel>
                          <div className="row">

                            <div className="col-md-12" style={{ marginTop: 30, marginLeft: 30, paddingRight: 50 }}>



                              <button className="btn ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-fill ttm-btn-color-skincolor" onClick={() => {
                                navigate("/dashboard/user/chat?userId=" + productDetails.user.id)
                              }}>{t("sendMessage")}</button>


                            </div>

                          </div>
                        </TabPanel>




                        <TabPanel>
                          {(showAvis && (
                            <div className="col-lg-12">
                              <div className="ttm-blog-classic-box-comment clearfix">
                                <div id="comments" className="comments-area">
                                  <div className="comment-respond">
                                    <h3 className="comment-reply-title">
                                      {t("leaveComment")}
                                    </h3>
                                    <p className="comment-notes">
                                      {t("importantOpinion")}
                                    </p>
                                    <Box>
                                      <Rating
                                        name="size-large"
                                        size="large"
                                        value={value}
                                        onChange={(event, newValue) => {
                                          setValue(newValue);
                                        }}
                                      />
                                    </Box>
                                    <p className="comment-form-comment">
                                      <textarea
                                        id="comment"
                                        placeholder={t("comment")}
                                        cols="45"
                                        rows="4"
                                        style={{ backgroundColor: "white" }}
                                        value={comment}
                                        onChange={(e) => {
                                          setComment(e.target.value);
                                        }}
                                      ></textarea>
                                    </p>
                                    <p
                                      className="form-submit margin_top30 margin_bottom0"
                                      onClick={() => {
                                        fetchAddAvis();
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <button className="submit ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-border ttm-btn-color-dark">
                                        {t("postComment")}
                                      </button>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}


                          {commentList.length > 0 && (
                            <>
                              {commentList.map((comm, index) => (
                                <div className="col-lg-12" key={index}>
                                  <div className="testimonials ttm-testimonial-box-view-style2">
                                    <div className="testimonial-content">
                                      <p className="float-sm-right font-size-12 text-center">
                                        {comm.created_at
                                          .split("T")[0]
                                          .split("-")
                                          .reverse()
                                          .join("/")}
                                        <br />
                                        {comm.created_at.split("T")[1].split(":")[0] +
                                          ":" +
                                          comm.created_at
                                            .split("T")[1]
                                            .split(":")[1]
                                            .split(".")[0]}
                                      </p>
                                      <div className="testimonial-bottom">
                                        <div className="testimonial-avatar">
                                          <div className="testimonial-img">
                                            <img
                                              className="img-fluid"
                                              src={require("../assets/FrontOffice/images/company.png")}
                                              alt="testimonial-img"
                                            />
                                          </div>
                                        </div>
                                        <div className="testimonial-caption">
                                          <h3 style={{ marginBottom: 10 }}>
                                            {getUserFullName(t, comm.user)}
                                          </h3>
                                          <Rating
                                            name="half-rating-read"
                                            defaultValue={comm.etoile_nb}
                                            precision={0.1}
                                            readOnly
                                          />
                                        </div>
                                      </div>
                                      <blockquote className="testimonial-text comm">
                                        {comm.commentaire}
                                      </blockquote>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}



                          {commentList.length == 0 && (
                            <div style={{ textAlign: "center", alignItems: "center", marginTop: 40 }}>
                              <h4 className="text-center">{t("detailproduit26.1")}</h4>
                            </div>
                          )}
                        </TabPanel>
                      </>
                    )}

                  </Tabs>
                </div>

              </div>


              {(productList.length > 0) && (
                <div className="row">
                  <div style={{
                    borderBottom: "1px solid lightgray", marginTop: 50,
                    width: "100%"
                  }}>
                    <h4>{t("similiarProducts")}</h4>
                  </div>

                  <ProductsComponent items={productList} itemsPerPage={4} />

                </div>
              )}
            </div>
          </section >
        )}
      </LoaderComponent >
      <Footer />
    </div >
  );
};

export default DetailProduit;
